<script>
export default {
  name: 'ProSurveySummary',
  props: {
    stats: {
      type: Object,
      default: () => ({
        totalSurveys: 0,
        completedSurveys: 0,
        draftSurveys: 0,
      }),
    },
    /** Current status filter: ALL | SUBMITTED | DRAFT. */
    active: { type: String, default: 'ALL' },
  },
  emits: ['select'],
  computed: {
    cards() {
      return [
        {
          key: 'ALL',
          tone: 'blue',
          label: "Nombre d'enquêtes",
          value: this.stats.totalSurveys,
          icon: 'ri-file-list-3-line',
        },
        {
          key: 'SUBMITTED',
          tone: 'green',
          label: 'Enquêtes complétées',
          value: this.stats.completedSurveys,
          icon: 'ri-checkbox-circle-line',
        },
        {
          key: 'DRAFT',
          tone: 'orange',
          label: 'Enquêtes en brouillon',
          value: this.stats.draftSurveys,
          icon: 'ri-draft-line',
        },
      ];
    },
  },
};
</script>

<template>
  <div class="pro-summary">
    <button
      v-for="card in cards"
      :key="card.key"
      type="button"
      class="pro-summary__card"
      :class="[
        `pro-summary__card--${card.tone}`,
        { 'pro-summary__card--active': active === card.key },
      ]"
      :aria-pressed="active === card.key"
      @click="$emit('select', card.key)"
    >
      <span class="pro-summary__stats">
        <span class="pro-summary__label">{{ card.label }}</span>
        <span class="pro-summary__value">{{ card.value }} Enquêtes</span>
        <span class="pro-summary__link">
          {{ active === card.key ? 'Filtre actif' : 'Voir tout' }}
        </span>
      </span>
      <span class="pro-summary__icon">
        <i :class="card.icon"></i>
      </span>
    </button>
  </div>
</template>

<style scoped>
.pro-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.pro-summary__card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  width: 100%;
  padding: 14px 20px;
  border: 0;
  border-radius: 7px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-align: left;
  cursor: pointer;
}

.pro-summary__card:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18);
}

/* The active card is the one filtering the list. */
.pro-summary__card--active {
  outline: 3px solid rgba(0, 91, 208, 0.35);
  outline-offset: 2px;
}

.pro-summary__card--blue {
  background: linear-gradient(135deg, #005bd0 0%, #00448c 100%);
}

.pro-summary__card--green {
  background: linear-gradient(135deg, #06d6a0 0%, #009c05 100%);
}

.pro-summary__card--orange {
  background: linear-gradient(135deg, #ff6b6b 0%, #ef9c0b 100%);
}

.pro-summary__stats {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.pro-summary__label {
  font-size: 9px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  text-transform: uppercase;
  letter-spacing: 0.27px;
}

.pro-summary__value {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  line-height: 1.1;
}

.pro-summary__link {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: underline;
}

.pro-summary__icon {
  flex: none;
  width: 44px;
  height: 44px;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pro-summary__icon i {
  font-size: 22px;
  color: #fff;
  line-height: 1;
}

@media (max-width: 900px) {
  .pro-summary {
    grid-template-columns: 1fr;
  }
}
</style>
